





import { Component, Vue, Watch } from 'vue-property-decorator'
import { checkBuilderType } from '@/utils/builder'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { ProjectIsGPT } from '@/utils/project'

@Component({
  name: 'App',
  components: {},
  computed: {
    ...mapGetters('buildergpt', ['getConfirmedSteps', 'getAccessibleStep']),
  },
  methods: {
    ...mapMutations('buildergpt', ['updateStateByLocalStorage', 'changeStep', 'setAccessToken']),
    ...mapMutations('builder', ['setAppCurrencyType']),

    ...mapActions('currency', ['fetchCurrency']),
  },
})
export default class App extends Vue {
  getAccessibleStep!: number
  getConfirmedSteps!: number[]
  setAppCurrencyType!: (any) => void
  setAppCurrency!: (any) => void
  updateStateByLocalStorage!: (any) => void
  setAccessToken!: (any) => void
  changeStep!: (any) => void
  fetchCurrency!: () => void
  get isGpt() {
    return ProjectIsGPT()
  }

  setCurrency() {
    this.setAppCurrencyType(this.$i18n.locale === 'ru' ? 'RUB' : 'USD')
  }

  gptStart() {
    // const localStorageData = localStorage.getItem('gpt_builder')
    // if(localStorageData) {
    //   this.updateStateByLocalStorage(JSON.parse(localStorageData))
    // }
    // this.changeStep(this.getAccessibleStep)
    this.$router.push({ path: `/gpt/step/${this.getAccessibleStep}` })
  }

  created(): void {
    this.fetchCurrency()

    if (checkBuilderType() === 'GPT') {
      document.title = String(this.$t('builderGpt.pagesTitle'))
      document.querySelector('meta[name="description"]')?.setAttribute('content', String(this.$t('builderGpt.pageDescription')))
      this.gptStart()
    }
    this.setCurrency()
  }

  @Watch('$route.name', { immediate: true })
  handler() {
    if (this.$route.name?.includes('step')) {
      this.changeStep(Number(this.$route.name.substring(4)))
    }
  }
}
